import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { AccountSummaryDto } from "@/types/api";

/**
 * Live account + pool snapshot. TanStack Query handles dedupe across
 * components (e.g. the PoolUsageCard); the API only gets hit once.
 */
export function useAccount(opts?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ["accounts", "me"],
    queryFn: ({ signal }) => api.get<AccountSummaryDto>("/api/accounts/me", signal),
    // Account header doesn't change often; let it stay fresh ~minute.
    staleTime: 60_000,
    // Callers on public pages pass enabled:false for anonymous visitors so
    // we don't fire a guaranteed-401 /me request.
    enabled: opts?.enabled ?? true
  });
}
